import "./../../Styles/Home/Home.css";

import Header from "./Header";
import Avatar from "./Avatar";
import Buscador from "./Buscador";

const Home = () => {
  return (
    <>
      <Header atri={"home"} />
      <Avatar />
      <Buscador />
    </>
  );
};

export default Home;
